import React, { useEffect } from 'react'
import slideImg1 from "../../../assets/images/idfcReg/slide-img1.png"
import brownArrow from "../../../assets/images/idfcReg/brown-arrow.png"
import Slider from 'react-slick'
import leftArrow from "../../../assets/images/slider/left-arrow.svg"
import RegOpenAccountFormIdfc from '../regOpenAccountFormIdfc'

function CustomLeftArrow(props) {
    const { className, style, onClick } = props;
    return (
        <img
            src={leftArrow}
            className={className}
            onClick={onClick}

        />
    );
}

function CustomRightArrow(props) {
    const { className, style, onClick } = props;
    return (
        <img
            src={leftArrow}
            className={className}
            onClick={onClick}
            alt="Right Arrow"
            style={{
                transform: 'rotate(180deg)', // Rotate the image 180 degrees
                cursor: 'pointer'            // Change cursor to pointer on hover
            }}
        />
    );
}


const IdfcLandingSection = () => {


    useEffect(() => {
        // Get all the accordion buttons
        const accordionButtons = document.querySelectorAll('.accordion-button');

        // Function to handle the click event
        const handleAccordionClick = (button) => {
            return () => {
                // Close all panels except the one clicked
                accordionButtons.forEach((btn) => {
                    if (btn !== button) {
                        btn.classList.remove('active');
                        btn.nextElementSibling.style.display = 'none';
                        btn.nextElementSibling.style.maxHeight = null;
                    }
                });

                // Toggle the active class to highlight the active button
                button.classList.toggle('active');

                // Toggle the visibility and max height of the panel
                const panel = button.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                    panel.style.display = 'none';
                } else {
                    panel.style.maxHeight = `${panel.scrollHeight + 74}px`;
                    panel.style.display = 'block';
                }
            };
        };

        // Add click event listeners to each accordion button
        accordionButtons.forEach((button, index) => {
            button.addEventListener('click', handleAccordionClick(button));

            // Open the first panel by default
            if (index === 0) {
                button.classList.add('active');
                button.nextElementSibling.style.maxHeight = `${button.nextElementSibling.scrollHeight + 74}px`;
                button.nextElementSibling.style.display = 'block';
            } else {
                button.nextElementSibling.style.display = 'none';
            }
        });

        // Cleanup event listeners on component unmount
        return () => {
            accordionButtons.forEach((button) => {
                button.removeEventListener('click', handleAccordionClick(button));
            });
        };
    }, []);

    const settings = {
        infinite: true,
        slidesToShow: 1,
        dots: true,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        nextArrow: <CustomRightArrow />,
        prevArrow: <CustomLeftArrow />,
        responsive: [
            {
                breakpoint: 1024, // 1024px or larger
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 768, // 768px or larger
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480, // 480px or larger
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    

    return (
        <>
            <section id="intro" className="clearfix">
                <RegOpenAccountFormIdfc />
            </section>

            {/* about section */}
            <section id="about">
                <div className="our-expert-course-outer arrowset paddingtop80 paddingbottom80">
                    <div className="container_new text-center">
                        <div className="f40 r16 font-bold text-brown">Why IDFC FIRST 3-in-1 account?</div>

                        <div className="mtop20 mob"></div>
                        <p className="text-brown f26 r12"> It's easy, efficient, and everything you need - all in one place</p>
                        <div className="mtop20"></div>


                        {/* new slider code */}
                        <div className="">
                            <Slider {...settings} className='our-expert-list'>

                                <div className="slider-items">
                                    <div className="">
                                        <div className="image-with-text">
                                            <img src={slideImg1} className="m-auto" />
                                        </div>



                                    </div>
                                </div>
                                <div className="slider-items">
                                    <div className="">
                                        <div className="image-with-text">
                                            <img src={slideImg1} className="m-auto" />
                                        </div>



                                    </div>
                                </div>
                                <div className="slider-items">
                                    <div className="">
                                        <div className="image-with-text">
                                            <img src={slideImg1} className="m-auto" />
                                        </div>



                                    </div>
                                </div>
                                <div className="slider-items">
                                    <div className="">
                                        <div className="image-with-text">
                                            <img src={slideImg1} className="m-auto" />
                                        </div>



                                    </div>
                                </div>
                                <div className="slider-items">
                                    <div className="">
                                        <div className="image-with-text">
                                            <img src={slideImg1} className="m-auto" />
                                        </div>



                                    </div>
                                </div>
                                <div className="slider-items">
                                    <div className="">
                                        <div className="image-with-text">
                                            <img src={slideImg1} className="m-auto" />
                                        </div>

                                    </div>
                                </div>

                            </Slider>
                        </div>
                    </div>
                </div>

            </section>

            {/* course accordion section */}
            <section className="course-accordion">
                <div className="container_new">
                    <p className="text-brown font-bold f28 r16">FAQs</p>
                    <div className="mtop16"></div>
                    <div className="accordion">
                        <div className="accord-sec">
                            <div className="margtop10"></div>
                            <button className="accordion-button">

                                <div className="dflex aligncenter spacebetween">
                                    <div className="module-name">

                                        <p className="f18">Who is eligible for a 3-in-1 account?
                                        </p>
                                    </div>
                                    <p className="f16 orange1 fw700">
                                        <span>
                                            <img src={brownArrow} className="downarrow" alt="" />
                                        </span>
                                    </p>

                                </div>
                            </button>

                            <div className="panel">
                                <div className="margtop10"></div>
                                <div className="">
                                    <p>What documents are required to open 3-in-1 account with us</p>
                                </div>
                            </div>
                        </div>

                        <div className="accord-sec">
                            <div className="margtop10"></div>
                            <button className="accordion-button">

                                <div className="dflex aligncenter spacebetween">
                                    <div className="module-name">

                                        <p className="f18">What documents are required to open 3-in-1 account with us?</p>
                                    </div>
                                    <p className="f16 orange1 fw700">
                                        <span>
                                            <img src={brownArrow} className="downarrow" alt="" />
                                        </span>
                                    </p>

                                </div>


                            </button>
                            <div className="panel">
                                <div className="margtop10"></div>
                                <div className="">
                                    <p>What documents are required to open 3-in-1 account with us</p>
                                </div>
                            </div>
                        </div>

                        <div className="accord-sec">
                            <div className="margtop10"></div>
                            <button className="accordion-button">


                                <div className="dflex aligncenter spacebetween">
                                    <div className="module-name">
                                        <p className="f18">Module 3: Technical Analysis
                                        </p>
                                    </div>
                                    <p className="f16 orange1 fw700">
                                        <span>
                                            <img src={brownArrow} className="downarrow" alt="" />
                                        </span>
                                    </p>

                                </div>


                            </button>
                            <div className="panel">
                                <div className="margtop10"></div>
                                <div className="">
                                    <p>What documents are required to open 3-in-1 account with us</p>
                                </div>
                            </div>
                        </div>

                        <div className="accord-sec">
                            <div className="margtop10"></div>
                            <button className="accordion-button">

                                <div className="dflex aligncenter spacebetween">
                                    <div className="module-name">

                                        <p className="f18">Who is eligible for a 3-in-1 account?
                                        </p>
                                    </div>
                                    <p className="f16 orange1 fw700">
                                        <span>
                                            <img src={brownArrow} className="downarrow" alt="" />
                                        </span>
                                    </p>

                                </div>
                            </button>

                            <div className="panel">
                                <div className="margtop10"></div>
                                <div className="">
                                    <p>What documents are required to open 3-in-1 account with us</p>
                                </div>
                            </div>
                        </div>

                        <div className="accord-sec">
                            <div className="margtop10"></div>
                            <button className="accordion-button">

                                <div className="dflex aligncenter spacebetween">
                                    <div className="module-name">

                                        <p className="f18">What documents are required to open 3-in-1 account with us?</p>
                                    </div>
                                    <p className="f16 orange1 fw700">
                                        <span>
                                            <img src={brownArrow} className="downarrow" alt="" />
                                        </span>
                                    </p>

                                </div>


                            </button>
                            <div className="panel">
                                <div className="margtop10"></div>
                                <div className="">
                                    <p>What documents are required to open 3-in-1 account with us</p>
                                </div>
                            </div>
                        </div>

                        <div className="accord-sec">
                            <div className="margtop10"></div>
                            <button className="accordion-button">

                                <div className="dflex aligncenter spacebetween">
                                    <div className="module-name">

                                        <p className="f18">Who is eligible for a 3-in-1 account?
                                        </p>
                                    </div>
                                    <p className="f16 orange1 fw700">
                                        <span>
                                            <img src={brownArrow} className="downarrow" alt="" />
                                        </span>
                                    </p>

                                </div>
                            </button>

                            <div className="panel">
                                <div className="margtop10"></div>
                                <div className="">
                                    <p>What documents are required to open 3-in-1 account with us</p>
                                </div>
                            </div>
                        </div>

                        <div className="accord-sec">
                            <div className="margtop10"></div>
                            <button className="accordion-button">

                                <div className="dflex aligncenter spacebetween">
                                    <div className="module-name">

                                        <p className="f18">What documents are required to open 3-in-1 account with us?</p>
                                    </div>
                                    <p className="f16 orange1 fw700">
                                        <span>
                                            <img src={brownArrow} className="downarrow" alt="" />
                                        </span>
                                    </p>

                                </div>


                            </button>
                            <div className="panel">
                                <div className="margtop10"></div>
                                <div className="">
                                    <p>What documents are required to open 3-in-1 account with us</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* footer section */}
            <footer id="footer">
                <div className="container_new">
                    <div className="copyright text-black">
                        <p className="f14 font-bold">Disclaimer: 3 in1 Account is a joint offering of Savings and Demat account with IDFC FIRST Bank and Trading account with Motilal Oswal.</p>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default IdfcLandingSection;
